import styled from "styled-components";

export const UserSettingsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: 100%;
  height: 100%;
  max-height: 600px;
  border-radius: 16px;
  background: ${(props) => props.theme.neutralLighter};
  box-shadow: inset 0 6px 0 0 ${({ theme }: {theme: any}) => theme.themePrimary};

  .ms-DetailsRow {
    &:hover .mgt-person {
      background: ${(props) => props.theme.neutralLighter};
    }
    .mgt-person {
      background: ${(props) => props.theme.white};
    }
  }

  .tableView {
    position: relative;
    height: 100%;
    overflow: scroll;
  }
`;

export const UserSettingsTableHeader = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  justify-content: space-between;
  margin-bottom: 16px;

  .filterInput {
    padding: 0.2rem 1rem;
    border: 2px solid ${({ theme }: {theme: any}) => theme.neutralQuaternaryAlt};
    background: ${({ theme }: {theme: any}) => theme.neutralLighterAlt};
    color: ${({ theme }: {theme: any}) => theme.black};
    border-radius: 8px;

    .filterInput:focus-visible {
      border: 2px solid ${({ theme }: {theme: any}) => theme.themePrimary};
      svg {
        color: ${({ theme }: {theme: any}) => theme.themePrimary};
      }
    }
  }

  .addUserContainer {
    display: flex;
    gap: 0.5rem;
    max-width: 650px;
  }

  input.control#control {
    display: none;
  }
`;

export const AddUserButton = styled.button`
  display: flex;
  width: fit-content;
  align-items: center;
  padding: 8px 16px;
  gap: 6px;
  border-radius: 8px;
  border: none;
  font: 700 0.9rem/1.1rem "Roboto", sans-serif;
  background: ${({ theme }: {theme: any}) => theme.themePrimary};
  color: #fff;
  cursor: pointer;

  &:hover {
    filter: brightness(1.3);
    transition: all 0.3s ease;
  }
`;

export const ColumnItemList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .item {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    h1 {
      font: 400 0.9rem/0.9rem "Roboto", sans-serif;
      color: ${({ theme }: {theme: any}) => theme.black};
    }

    h2 {
      font: 600 0.9rem/0.9rem "Roboto", sans-serif;
      color: ${({ theme }: {theme: any}) => theme.neutralDark};
    }

    i {
      color: ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }
`;

export const TableContainer = styled.div`
  .table {
    border-radius: 1rem;

    div[role="row"]:not(.ms-DetailsHeader):hover {
      background: ${({ theme }: {theme: any}) => theme.neutralLighterAlt};
    }

    div[role="columnheader"]:hover {
      background: ${({ theme }: {theme: any}) => theme.neutralQuaternary};
    }

    .ms-DetailsHeader {
      padding: 0;
      background: ${({ theme }: {theme: any}) => theme.neutralQuaternaryAlt};

      * {
        color: ${({ theme }: {theme: any}) => theme.black};
      }
    }

    .ms-List-page {
      background: ${(props) => props.theme.white};
    }
  }
`;

export const ManageButton = styled.button`
  display: flex;
  height: 100%;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;

  svg {
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  &:hover svg {
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
    transition: all 0.2s;
  }
`;
